import { render, staticRenderFns } from "./UtilizzoMateriali.vue?vue&type=template&id=0e426e37&scoped=true&"
import script from "./UtilizzoMateriali.vue?vue&type=script&lang=js&"
export * from "./UtilizzoMateriali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e426e37",
  null
  
)

export default component.exports